'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = makeDecorator;

function makeDecorator(fn) {
  return function (target, prop, descriptor) {
    if (typeof descriptor !== 'undefined') {
      descriptor.value = fn(descriptor.value);
      return descriptor;
    }
    return fn(target);
  };
}

module.exports = exports['default'];